import { EApiLanguages, TBrand } from "@cakemail-org/ui-components-v2"
import { TDropMenuItem } from "@cakemail-org/ui-components-v2/dist/esm/components/dropMenu/types"
import { t } from "i18next"

export function supportedLocales() {
    return [
        {
            text: t("general-languages_en-US"),
            value: "en_US",
            supportLink: "en-us",
        },
        {
            text: t("general-languages_fr-CA"),
            value: "fr_CA",
            supportLink: "fr",
        },
        {
            text: t("general-languages_nl-NL"),
            value: "nl_NL",
            supportLink: "nl-nl",
        },
        {
            text: t("general-languages_es-ES"),
            value: "es_ES",
            supportLink: "es-es",
        },
        {
            text: t("general-languages_pt-BR"),
            value: "pt_BR",
            supportLink: "pt-br",
        },
        {
            text: t("general-languages_es-US"),
            value: "es_US",
            supportLink: "es-us",
        },
        {
            text: t("general-languages_fi"),
            value: "fi",
            supportLink: "fi",
        },
        {
            text: t("general-languages_sv"),
            value: "sv",
            alternative: "sv_SE",
            supportLink: "sv",
        },
        {
            text: t("general-languages_it"),
            value: 'it',
            supportLink: "it",
        },
        {
            text: t("general-languages_el-GR"),
            value: 'el_GR',
            supportLink: "el-GR",
        },
    ]
}


function getLanguages({ languageList = undefined, resellerBrand, simpleArray }: { languageList?: string[], resellerBrand?: TBrand, simpleArray?: boolean } = {}): { text: any, value: string, supportLink?: string, alternative?: string }[] {
    const defaultLocals = ["en_us", "fr_ca"]
    let resellerLocales = languageList || resellerBrand?.client_config?.languages || []
    let localesToUse = []

    if (resellerLocales && resellerLocales.length > 0) {
        resellerLocales = resellerLocales.map((locale: string) => locale.toLowerCase())
        localesToUse = supportedLocales().filter((locale) => {
            return resellerLocales.includes(locale.value.toLowerCase())
        })
    } else {
        localesToUse = supportedLocales().filter((locale) => {
            return defaultLocals.includes(locale.value.toLowerCase())
        })
    }
    return localesToUse
}


export function getSimpleLanguagesValues(resellerBrand?: TBrand, prefixToAdd: string = "", toLowerCase?: boolean): string[] {
    return getLanguages({ resellerBrand })?.map((l) => {
        return formatLang({ lang: l, prefixToAdd, toLowerCase }).value || ""
    }) || []
}

export function getLanguagesOptions({ resellerBrand, prefixToAdd, toLowerCase, useApiLanguages }: { resellerBrand?: TBrand, prefixToAdd?: string, toLowerCase?: boolean, useApiLanguages?: boolean }): TDropMenuItem[] {
    if (useApiLanguages) {
        return Object.values(EApiLanguages).map((l) => {
            return formatLang({ lang: { value: l }, prefixToAdd, toLowerCase })
        })
    }

    return getLanguages({ resellerBrand }).map((language, index) => {
        return formatLang({ lang: language, prefixToAdd, toLowerCase })
    })
}

function formatLang({ lang, prefixToAdd, toLowerCase }: { lang: TDropMenuItem, prefixToAdd?: string, toLowerCase?: boolean }) {
    let value = lang.value
    if (value && toLowerCase)
        value = value.toLocaleLowerCase()

    return {
        text: lang.text || t("general-languages_" + lang.value?.replace("_", "-")),
        value: prefixToAdd ? prefixToAdd + value : value
    }
}